import React from "react";

const PlansIndex = () => {
  return <div>PlansIndex</div>;
};

export default PlansIndex;
